import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  isOverTop: boolean
  isOverBottom: boolean
  expanded: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    position: 'relative'
  },

  label: {
    marginLeft: '0.5rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    userSelect: 'none'
  },

  chip: {
    margin: '0 0.5rem 0.25rem 0',
    alignContent: 'center',
    padding: '0.35rem 0.5rem',
    backgroundColor: '#F1F1F1',
    color: 'grey',
    borderRadius: '0.75rem',
    border: '0.0625rem solid white'
  },

  descRow: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center'
  },

  chipOptions: {
    display: 'flex',
    gap: '0.25rem',
    alignItems: 'center',
    '& > svg': {
      cursor: 'pointer'
    }
  },

  drop: {
    width: '100%',
    height: '0.25rem !important'
  },

  dropTop: {
    background: ({ isOverTop }) =>
      isOverTop ? theme.palette.primary.main : 'transparent'
  },
  expandIcon: {
    transform: ({ expanded }) => (expanded ? 'rotate(180deg)' : 'rotate(0deg)')
  },

  dropBottom: {
    background: ({ isOverBottom }) =>
      isOverBottom ? theme.palette.primary.main : 'transparent'
  },

  expandedRoot: {
    paddingTop: '0.25rem',
    display: 'flex',
    flexFlow: 'column',
    gap: '0.5rem'
  },

  conditionsLabel: {
    fontSize: theme.size.sm
  },

  addConditionBtn: {
    width: 'fit-content'
  }
}))

export default useStyles
